import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Vishvachaitanya Wagh </span>
            from <span className="purple"> Pune, India.</span>
            <br />
            I am currently a passionate student pursuing Bachelor's Degree in Computer Scinece at Dr D.Y. Patil Institute Of Technology Pimpri,Pune.
            <br />
            I have completed Diploma (Polytechnique) in Computer Enggneering at Government Polytechnique, MZR.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Passionate Coder who builds stuffs via programing!"{" "}
          </p>
          <footer className="blockquote-footer">Vishva</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
